import PlurallClient from '@plurall/client'
import { getToken } from './token'

const { REACT_APP_PLURALL_API_URL, REACT_APP_SOMOS_GRAPHQL_URL, REACT_APP_SOMOS_ID_MS_API_CLIENT_ID } = process.env

class Client {
  constructor(config = {}) {
    this.client = new PlurallClient({
      accept: config.accept || 'vnd.plurall.api.v2+json',
      applicationId: REACT_APP_SOMOS_ID_MS_API_CLIENT_ID,
      accessToken: config.accessToken || getToken(),
      apiURL: config.apiURL || REACT_APP_PLURALL_API_URL,
      graphqlURL: REACT_APP_SOMOS_GRAPHQL_URL,
      disableAutoCamelize: false,
    })

    this.getProfile = this.client.profile.get
  }

  async checkGoogleEntity() {
    return this.client.get('/external-entity/user/somosid/google')
  }

  async checkExternalReference(meetLink, personId) {
    const reference = await this.client.restClient.get(`meet-api/meet/externalReference?meetLink=${meetLink}&personId=${personId}`)
    return reference
  }
}

export default Client
